// src/pages/Login.jsx
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import authApi from "../api/auth";
import { setCredentials } from "../auth/authSlice";
import { getDefaultRouteByRole } from "../utils/roleRoute";
import { storeToken, storeRefreshToken, storeUser } from "../utils/localStorage";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((s) => s.auth.user);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);



  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await authApi.loginUser({ username, password });

      if (!data || data.status !== "success") {
        throw new Error(data.message || "Invalid Credentials");
      }

      const { access_token, refresh_token, user } = data;

      // Save to Redux
      dispatch(setCredentials({ user, access_token, refresh_token }));

      // Save to localStorage
      storeToken(access_token);
      storeRefreshToken(refresh_token);
      storeUser(user);

      // Redirect based on role
      const redirect = getDefaultRouteByRole(user.role);
      navigate(redirect, { replace: true });
    } catch (err) {
      console.error("[Login] Login failed:", err);
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

return (
  <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
    <div className="card shadow" style={{ width: "380px" }}>
      
      {/* Header */}
      <div className="card-body text-center pt-4">
        <h2 className="fw-bold text-primary">Aadhav</h2>
        <p className="text-muted small mb-4">
          Sign in to start your session
        </p>

        {error && (
          <div className="alert alert-danger py-2">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          
          {/* Username */}
          <div className="input-group mb-3">
            <span className="input-group-text">
              <i className="fas fa-user"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          {/* Password */}
          <div className="input-group mb-3">
            <span className="input-group-text">
              <i className="fas fa-lock"></i>
            </span>
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {/* Button */}
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  </div>
);

};

export default Login;
